// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDJhIksOpRipaUsaXoq9S9PMYnP9mhIi4U",
  authDomain: "spendsage-web.firebaseapp.com",
  projectId: "spendsage-web",
  storageBucket: "spendsage-web.appspot.com",
  messagingSenderId: "248826847032",
  appId: "1:248826847032:web:27531f19771b333d3eebcd",
  measurementId: "G-FMBGSK4HQ3"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);